<template>
  <div class="table-container">
    <div class="table-header">
      <div class="w-100 d-flex">
        <table-header
          v-for="header in headers"
          :key="header.id"
          :title="header.title"
        />
      </div>
    </div>
    <div class="table-lines">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
import TableHeader from "./TableHeader.vue";
export default {
  components: { TableHeader },
  props: {
    title: {
      type: String,
    },
    headers: {
      type: Array,
    },
  },
};
</script>
<style scoped lang="scss">
.table-container {
  position: relative;
  min-width: 1100px; // Ensures table doesn't shrink too much on mobile
}

.table-header {
  min-height: 70px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
}

.table-lines {
  // padding: 20px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  // overflow-y: scroll;
  max-height: 600px;
  overflow-y: auto;
}

.table-line {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid $tableOrderColor;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.02);
  }
}

@media only screen and (max-width: 768px) {
  .table-container {
    border-radius: 6px;
  }

  .table-header {
    padding: 10px;
  }

  .table-lines {
    max-height: 400px;
  }

  .table-line {
    padding: 8px 10px;
  }
}
</style>
